const LAYOUT_CONST = {
    VERTICAL_LAYOUT: 'vertical',
    HORIZONTAL_LAYOUT: 'horizontal',
    DEFAULT_DRAWER: 'default',
    MINI_DRAWER: 'mini-drawer'
};

export const ENITipoDocumental = {
    TD01: 'Resolución',
    TD02: 'Acuerdo',
    TD03: 'Contrato',
    TD04: 'Convenio',
    TD05: 'Declaración',
    TD06: 'Comunicación',
    TD07: 'Notificación',
    TD08: 'Publicación',
    TD09: 'Acuse de recibo',
    TD10: 'Acta',
    TD11: 'Certificado',
    TD12: 'Diligencia',
    TD13: 'Informe',
    TD14: 'Solicitud',
    TD15: 'Denuncia',
    TD16: 'Alegación',
    TD17: 'Recursos',
    TD18: 'Comunicación ciudadano',
    TD19: 'Factura',
    TD20: 'Otros incautados',
    TD99: 'Otros'
};

export default LAYOUT_CONST;
